import ManageModal from './manage-modal'
import GenerateServiceRequestModal from './generate-sr-modal'

export { ManageModal, GenerateServiceRequestModal }